<div class="main-container background-img">
    <div class="container pl-md-0">
      <div class="row pt-3">
        <div class="col-md-8">
          <a>
            <img [src]="'https://advisorassessment.ipcdigital.ca/assets/ipc-logo.png' | translate" class="ipc-logo" alt="ipc logo">
          </a>
        </div>

      </div>
    </div>
    <div class="container mt-5 text-center shadow p-3 mb-5 bg-white rounded">
      <div class="row p-5">
        <div class="col-md-8 offset-md-2">
            <span class="display-1">Oops!</span>
            <h2 class="mt-5">404 <br> PAGE NOT FOUND</h2>
            <p>The page you are looking for might have been removed or had its name changed or is temorarily unavailable.</p>
            <a class="btn btn-sucess" href="./#/en/advisor/ipc">Go Back To Corporate Site</a>
        </div>
      </div>
  
    </div>
  </div>
  
  <footer class="footer">
    <div class="container pl-md-0">
      <div class="row">
        <div class="col-md-12 top-footer-text mt-4 text-center">
          <h3 class="font-weight-bold">HEAD OFFICE</h3>
          <p>5015 Spectrum Way. Mississauga, ON. Canada</p>
          <p>Phone: <a class="top-footer-text" href="tel:905-212-9799">905-212-9799</a></p>
          <hr class="footer-hr">
          <p class="bottom-footer-text">© 2020 <a class="bottom-footer-text" href="https://www.ipcc.ca"
              target="_blank">Investment Planning
              Counsel</a></p>
        </div>
      </div>
    </div>
  </footer>